import React, { useState, useEffect, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';

// material
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  TablePagination,
  TableHead,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Dialog,
  Divider,
  Avatar,
} from '@mui/material';
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// components
import axios from 'axios';
import Scrollbar from './Scrollbar';
// mock
import PopupComponent from './PopupComponent';
import AddCategory from './AddCategory';
import LoadingIcon from './smallComponents/LoadingIcon';
import { commonHeadStyle, commonBodyStyle } from '../theme/commonStyles';

// import { FilterForm } from '../components/FilterForm';

// ----------------------------------------------------------------------

// const customToolBar = ({setFilter})
export default function ProjectCategories() {
  const navigate = useNavigate();
  const [projectCategoryData, setProjectCategoryData] = useState();
  const [pages, setPages] = useState(0);
  const [projectCategoryCount, setProjectCategoryCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState();
  const size = 10;
  const [options, setOptions] = useState({ size, page: 0 });
  const [input, setInput] = useState(1);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    getProjectCategories(options);
  }, []);

  const getProjectCategories = (options) => {
    console.log(options);
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/category/all`, {
        params: options,
      })
      .then((res) => {
        console.log('ressssssssssss', res);
        if (res.data.isError === false) {
          setProjectCategoryCount(res.data.data.maxRecords);
          setProjectCategoryData(res.data.data.categories);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const handleStatusChange = (event, item, index) => {
    console.log('item', item);
    if (`${item.isactive}` === event.target.value) {
      return;
    }
    setSelectedIndex(index);
  };

  const handleAddModal = () => {
    setOpenModal(!openModal);
  };

  const handleClose = (refresh = false, message = '') => {
    setSelectedIndex();
    console.log(refresh);
    if (refresh) {
      getProjectCategories(options);
    }
    if (message) {
      toast(message);
    }
  };

  const handlePageChange = (event, newPage) => {
    setPages(newPage);
    const temp = { ...options, page: newPage };
    setOptions(temp);
    getProjectCategories(temp);
  };

  const applyFilters = (filter) => {
    console.log('filter', filter);
    const temp = { page: 0, size };
    if (filter.name.trim()) {
      temp.name = filter.name.trim();
    }
    if (filter.isBlocked) {
      temp.isBlocked = filter.isBlocked;
    }
    setOptions(temp);
    setPages(0);
    getProjectCategories(temp);
  };

  const goToPage = () => {
    if (input > Math.ceil(projectCategoryCount / size)) {
      return;
    }
    setInput(input > 0 ? input : 1);
    setPages(input - 1 >= 0 ? input - 1 : 0);
    const temp = { ...options, page: input - 1 };
    setOptions(temp);
    getProjectCategories(temp);
  };

  const handleAddSuccess = () => {
    getProjectCategories(options);
  };

  return (
    <>
      {isLoading ? (
        <LoadingIcon />
      ) : (
        <>
          <Dialog open={openModal} onClose={handleAddModal}>
            <PopupComponent closePopup={handleAddModal} title={'Create New Category'}>
              <AddCategory closePopup={handleAddModal} handleAddSuccess={handleAddSuccess} />
            </PopupComponent>
          </Dialog>
          <Stack direction="row" alignItems="center" justifyContent="end" my={5}>
            <Stack direction="row" spacing={1.5}>
              <Button variant="contained" onClick={handleAddModal} color="buttonone">
                New Category
              </Button>
            </Stack>
          </Stack>
          <Card>
            <Stack direction="row" spacing={2} padding={2} justifyContent={'space-between'}>
              <Stack direction="row" spacing={1.5}>
                <TextField
                  size="small"
                  style={{ maxWidth: '100px' }}
                  type="number"
                  component="div"
                  label="Go to"
                  value={input}
                  onInput={(e) => setInput(e.target.value)}
                />
                <Button
                  variant="contained"
                  onClick={goToPage}
                  sx={{
                    backgroundColor: '#0096DB',
                    height: '40px',
                  }}
                >
                  Go
                </Button>
              </Stack>
              {/* <Filter applyFilters={applyFilters} /> */}
            </Stack>
            <Divider
              sx={{
                background: ' rgba(0, 0, 0, 0.50)',
                marginBottom: '24px',
              }}
            />
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={commonHeadStyle}>Sl No</TableCell>
                      <TableCell sx={commonHeadStyle}>Name</TableCell>
                      <TableCell sx={commonHeadStyle}>Icon</TableCell>
                      <TableCell sx={commonHeadStyle}>Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {projectCategoryData?.map((item, id) => (
                      <TableRow key={id}>
                        <TableCell sx={{ ...commonBodyStyle, width: '120px' }}>{pages * size + (id + 1)}</TableCell>
                        <TableCell
                          sx={{ ...commonBodyStyle, cursor: 'pointer' }}
                          onClick={() => navigate(`/dashboard/member/${item._id}`)}
                        >
                          <Typography sx={commonBodyStyle}>{item.name}</Typography>
                        </TableCell>
                        <TableCell sx={commonBodyStyle}>
                          <Avatar
                            sx={{
                              width: '30px',
                              height: '30px',
                              backgroundColor: '#F4F4F4',
                            }}
                            src={item.icon}
                          >
                            {item?.icon ? '' : item?.name?.charAt(0)}
                          </Avatar>
                        </TableCell>
                        <TableCell sx={commonBodyStyle}>
                          <FormControl sx={{ minWidth: 120 }}>
                            <Select
                              size="small"
                              sx={commonBodyStyle}
                              value={item.isBlocked}
                              onChange={(e) => handleStatusChange(e, item, id)}
                            >
                              <MenuItem sx={commonBodyStyle} value="false">
                                Active
                              </MenuItem>
                              <MenuItem sx={commonBodyStyle} value="true">
                                Blocked
                              </MenuItem>
                            </Select>
                            {/* {selectedIndex === id && <Popup item={item} handleClose={handleClose} />} */}
                          </FormControl>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
            <TablePagination
              rowsPerPageOptions={[]}
              component={'div'}
              count={projectCategoryCount}
              onPageChange={handlePageChange}
              rowsPerPage={rowsPerPage}
              page={pages}
              showFirstButton
              showLastButton
            />
          </Card>
        </>
      )}
    </>
  );
}
